import { render, staticRenderFns } from "./AlertsCRUD.vue?vue&type=template&id=173558e3&"
import script from "./AlertsCRUD.vue?vue&type=script&lang=js&"
export * from "./AlertsCRUD.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports